<styles-smart-table
  #smartTable
  [datasource]="pendingProjects.items"
  [mainColumns]="buildMainColumns()"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef>Organization</th>
    <td mat-cell *matCellDef="let element">
      <styles-icon-value-caption caption="Organization" icon="corporate_fare" *ngIf="element.feedDetails">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="instanceType">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let element">
      <ng-container *ngIf="isMulti(element); else singleProject"> Multi </ng-container>
      <ng-template #singleProject> One-Off </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef>Start Date</th>
    <td mat-cell *matCellDef="let element">
      <styles-icon-value-caption caption="Start Date" icon="date_range" *ngIf="isMulti(element); else singleProject">
        {{ $any(resolveLine(element))?.phaseStart | date : 'mediumDate' }}
      </styles-icon-value-caption>

      <ng-template #singleProject>
        <styles-icon-value-caption caption="Start Date" icon="date_range">
          {{ $any(element)?.projectStartDate | date : 'mediumDate' }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="endDate">
    <th mat-header-cell *matHeaderCellDef>End Date</th>
    <td mat-cell *matCellDef="let element">
      <styles-icon-value-caption caption="End Date" icon="date_range" *ngIf="isMulti(element); else singleProject">
        <ng-container *ngIf="($any(resolveLine(element))?.phaseEnd | isRolling) === false">
          {{ $any(resolveLine(element))?.phaseEnd | date : 'mediumDate' }}
        </ng-container>
        <ng-container *ngIf="($any(resolveLine(element))?.phaseEnd | isRolling) === true"> Rolling </ng-container>
      </styles-icon-value-caption>

      <ng-template #singleProject>
        <styles-icon-value-caption caption="End Date" icon="date_range">
          {{ $any(element)?.projectEndDate | date : 'mediumDate' }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">
      <div>
        <div
          class="title ellipsis-text"
          [routerLink]="['/sows', resolveParentProject(element).id, 'projects']"
          [queryParams]="{contractLine: resolveLine(element).id + ':' + element.name }"
        >
          {{$any(element).name}}
        </div>
        <div class="sub-title">
          <mat-icon class="color-icon"> hourglass_bottom </mat-icon>
          <div class="ellipsis-text">{{$any(element)?.contractType }}</div>
          <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef>Content Type</th>
    <td mat-cell *matCellDef="let element">
      <styles-icon-value-caption
        caption="Content Type"
        icon="category"
        *ngIf="($any(element)?.productType || ($any(element)?.productTypes && $any(element).productTypes!.length > 0)); else noContentType"
        [matTooltip]="$any(element).productType?.name"
      >
        <ng-container *ngIf="$any(element)?.productTypes; else singleType">
          <ng-container *ngFor="let type of $any(element)?.productTypes; last as isLast"
            >{{ type.name }} <ng-container *ngIf="!isLast">&nbsp;•&nbsp;</ng-container>
          </ng-container>
        </ng-container>
        <ng-template #singleType> {{ $any(element).productType.name }}</ng-template>
      </styles-icon-value-caption>
      <ng-template #noContentType>
        <styles-icon-value-caption
          caption="Product Type"
          icon="category"
          *ngIf="element.productInstance"
          [matTooltip]="$any(element)?.productInstance.name"
        >
          {{ $any(element)?.productInstance.name }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let element">
      <framework-work-status-chip [workStatus]="$any(element)?.status"> </framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef>Units</th>
    <td mat-cell *matCellDef="let element">
      <div class="units-container">
        <div class="unit-wrapper" *ngIf="$any(resolveLine(element))?.units?.totalUnits > 0">
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === true"
          >
            {{ $any(resolveLine(element)).units?.totalUnits | unitsPerMonth : (isMulti(element) ?
            $any(resolveLine(element))?.phaseStart : $any(element)?.projectStartDate) : (isMulti(element) ?
            $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | number : '1.0-0'}} pcm
          </div>
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === false"
          >
            {{ $any(resolveLine(element)).units?.totalUnits | number : '1.0-2'}}
          </div>
          <div class="unit-title">Total Units</div>
        </div>

        <div
          class="unit-wrapper"
          *ngIf="$any(resolveLine(element))?.units?.plannedUnits > 0 && isMulti(element) === true;"
        >
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === true"
          >
            {{ $any(resolveLine(element)).units?.plannedUnits | unitsPerMonth : (isMulti(element) ?
            $any(resolveLine(element))?.phaseStart : $any(element)?.projectStartDate) : (isMulti(element) ?
            $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | number : '1.0-0'}} pcm
          </div>
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === false"
          >
            {{ $any(resolveLine(element)).units?.plannedUnits | number : '1.0-2'}}
          </div>
          <div class="unit-title">Planned</div>
        </div>

        <div class="unit-wrapper" *ngIf="$any(resolveLine(element))?.units?.unplannedUnits > 0">
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === true"
          >
            {{ $any(resolveLine(element)).units?.unplannedUnits | unitsPerMonth : (isMulti(element) ?
            $any(resolveLine(element))?.phaseStart : $any(element)?.projectStartDate) : (isMulti(element) ?
            $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | number : '1.0-0'}} pcm
          </div>
          <div
            class="value"
            *ngIf="((isMulti(element) ? $any(resolveLine(element))?.phaseEnd : $any(element)?.projectEndDate) | isRolling) === false"
          >
            {{ $any(resolveLine(element)).units?.unplannedUnits | number : '1.0-2'}}
          </div>
          <!-- <div class="value">{{ $any(resolveLine(element)).units?.unplannedUnits | number : '1.0-2'}}</div> -->
          <div class="unit-title">UnPlanned</div>
        </div>

        <div
          class="unit-wrapper"
          *ngIf="$any(resolveLine(element))?.units?.incompletedUnits > 0 && isMulti(element) === true"
        >
          <div class="value">{{ $any(resolveLine(element)).units?.incompletedUnits | number : '1.0-2'}}</div>
          <div class="unit-title">InComplete</div>
        </div>

        <div class="unit-wrapper" *ngIf="$any(resolveLine(element))?.units?.completedUnits > 0">
          <div class="value">{{ $any(resolveLine(element)).units?.completedUnits | number : '1.0-2'}}</div>
          <div class="unit-title">Completed</div>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <framework-action-button [project]="$any(element)" [iconSize]="18" *ngIf="$any(element)?.defaultAction">
      </framework-action-button>
      <shared-listing-action-dropdown
        menu
        *ngIf="($any(element)?.actions)!.length > 0"
        [level]="element.module === 'MasterProject' ? 'master' : 'project'"
        [location]="element | moduleTypePipe"
        [masterProject]="element | findMaster"
        [project]="element | findSpace"
        [phase]="element | phasePipe"
        [task]="element"
        [actions]="$any(element)?.actions"
      >
      </shared-listing-action-dropdown>
    </td>
  </ng-container>
</styles-smart-table>
